var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"digital-flop"}},[_c('module-title',{attrs:{"title":"今日多渠道销售环图占比"}}),_c('div',{staticStyle:{"width":"100%","height":"80%"},attrs:{"id":"todayChart"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }